import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_dashboard/$account/graphql/$graph/branches/$branch/settings/',
)({
  staticData: { title: '[graph] - Settings' },
  beforeLoad: () => {
    throw redirect({
      from: '/$account/graphql/$graph/branches/$branch/settings',
      to: '/$account/graphql/$graph/branches/$branch/settings/graph',
    })
  },
})
